import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";

const OrgWiseDeviceLockUnlockList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getOrgPermissions } = useHttp();

  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
      }
    }
  }, []);

  useEffect(() => {
    getOrgPermissions(
      {
        url: `/api/organizationServiceAllocation/`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          setData(res);
        }
      }
    );
  }, [getOrgPermissions]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              User Device Lock/ Unlock
            </label>
          </div>
          <div className="col-3 text-right"></div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Permissions
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Org Name</th>

                          <th>Edit</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.orgName}</td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(itm);
                                      props.addForm(true);
                                    }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default OrgWiseDeviceLockUnlockList;
